import React from 'react';
import { useSelector } from 'react-redux';
import { Col, Row } from '../../../../Grid/index.js';
import { Checkbox } from '../../../../index.js';
const Interest = (props) => {
    const lang = useSelector((s) => s.lang);
    return (React.createElement(Row, null,
        React.createElement(Col, { width: "12" },
            React.createElement("h3", null, "Rubrik 3"),
            React.createElement(Row, null,
                React.createElement(Col, { width: "6" },
                    React.createElement(Checkbox, { style: { display: 'inline-block' }, placeholder: lang.documents.interestFromSubmitOfBPK, checked: props.interestFromSubmitOfBPK, onChange: (e) => {
                            props.setDocumentState({
                                interestFromSubmitOfBPK: e.target.checked,
                            });
                        } }))))));
};
export default Interest;
//# sourceMappingURL=Interest.js.map